module.exports = __webpack_public_path__ + "media/images/logos/01-81224bf642c08a7ea44bab4c3ea16ecb.png";